export class NegativeIdGenerator {
  static id: number = 0;

  static next = (): number => {
    NegativeIdGenerator.id--;
    return NegativeIdGenerator.id;
  };
}
